import React, { useState } from 'react';
import { Button, FormControl } from 'react-bootstrap';
import { SketchPicker } from 'react-color';

const BoardLabelAddForm = () => {
    //comp state
    const [labelName, setLabelName] = useState('')
    const [labelColor, setLabelColor] = useState('')
    const [error, setError] = useState('');

    return (
        <div>
            <FormControl value={labelName} placeholder="Label Name" onChange={(e) => setLabelName(e.target.value)} />
            <SketchPicker
                className="mt-3"
                color={labelColor}
                onChange={(color) => setLabelColor(color.hex)}
            />
            <Button className="mt-2" variant="outline-secondary" size="sm">Add</Button>
            {error && <p className="text-red">{error}</p>}
        </div>
    )
}

export default BoardLabelAddForm
